import { ProgramSerializer } from 'modules/handlebars/domain/program';
import { ConditionalContent } from '../../domain';
import { createProgramFromConditionalContent } from './createProgramFromConditionalContent';

export const serializeConditionalContent = (content: ConditionalContent) => {
  const program = createProgramFromConditionalContent(content);
  return ProgramSerializer.serialize(program);
};
